export default __webpack_public_path__ + "static/media/nexus-logo.7d37e3f0.png";